import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-33f6e1b6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "list-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_page_header = _resolveComponent("el-page-header");
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createBlock(_component_el_container, {
    class: "log-container"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      class: "manage-header"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_page_header, {
        content: "使用配额"
      })]),
      _: 1
    }), _createVNode(_component_el_main, {
      class: "log-list"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_table, {
        data: _ctx.orderList,
        "header-cell-class-name": 'table-head',
        id: "table_loading"
      }, _createSlots({
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "orderNo",
          label: "订单编号"
        }), _createVNode(_component_el_table_column, {
          prop: "buyCount",
          label: "已购买配额"
        }), _createVNode(_component_el_table_column, {
          prop: "usedCount",
          label: "已使用配额"
        }), _createVNode(_component_el_table_column, {
          prop: "validStartTime",
          label: "开始时间"
        }), _createVNode(_component_el_table_column, {
          prop: "validEndTime",
          label: "结束时间"
        })]),
        _: 2
      }, [_ctx.isShowNull ? {
        name: "empty",
        fn: _withCtx(() => [_createVNode(_component_el_empty, {
          description: "暂无数据"
        })]),
        key: "0"
      } : undefined]), 1032, ["data"])])]),
      _: 1
    })]),
    _: 1
  });
}